import CreateStoreSettingsPage from './CreateStoreSettingsPage';

export default CreateStoreSettingsPage;
